export const standingCommittees = [
  { label: "Not Applicable / લાગુ નથી", value: "Not Applicable / લાગુ નથી" },
  { label: "Women Wing / મહિલા વિંગ", value: "Women Wing / મહિલા વિંગ" },
  { label: "Youth Wing / યુવા વિંગ", value: "Youth Wing / યુવા વિંગ" },
  {
    label:
      "Education & Human Resources Development / એડ્યુકેશન અને એચ.આર.ડી.",
    value:
      "Education & Human Resources Development / એડ્યુકેશન અને એચ.આર.ડી.",
  },
  { label: "Healthcare / આરોગ્ય", value: "Healthcare / આરોગ્ય" },
  {
    label: "Business Development / બિઝનેસ ડેવલપમેંટ",
    value: "Business Development / બિઝનેસ ડેવલપમેંટ",
  },
  {
    label:
      "IT, Digital Transformation & AI / આય. ટી., ડિજિટલ ટ્રાન્સફોર્મેશન અને એ.આય.",
    value:
      "IT, Digital Transformation & AI / આય. ટી., ડિજિટલ ટ્રાન્સફોર્મેશન અને એ.આય.",
  },
  {
    label:
      "Media, Marketing & Communications / મીડિયા, માર્કેટિંગ અને કમ્યુનિકેશન",
    value:
      "Media, Marketing & Communications / મીડિયા, માર્કેટિંગ અને કમ્યુનિકેશન",
  },
  {
    label: "Environment & Sustainability / એન્વાયરમેન્ટ અને સસ્ટેનેબીલીટી",
    value: "Environment & Sustainability / એન્વાયરમેન્ટ અને સસ્ટેનેબીલીટી",
  },
  { label: "Lagna Setu / લગ્ન સેતુ", value: "Lagna Setu / લગ્ન સેતુ" },
  {
    label:
      "Travel, Tourism Hospitality & Catering / ટ્રાવેલ, ટૂરિઝમ, હોસ્પિટાલિટી અને કેટરિંગ",
    value:
      "Travel, Tourism Hospitality & Catering / ટ્રાવેલ, ટૂરિઝમ, હોસ્પિટાલિટી અને કેટરિંગ",
  },
  {
    label: "Sports & Recreation / સ્પોર્ટ્સ અને રિક્રિએશન",
    value: "Sports & Recreation / સ્પોર્ટ્સ અને રિક્રિએશન",
  },
  { label: "Legal / લીગલ", value: "Legal / લીગલ" },
  {
    label: "CA & Tax Professionals / સીએ અને ટેક્સ પ્રોફેશનલ્સ",
    value: "CA & Tax Professionals / સીએ અને ટેક્સ પ્રોફેશનલ્સ",
  },
  { label: "Aadhyaatmik / આધ્યાત્મિક", value: "Aadhyaatmik / આધ્યાત્મિક" },
  {
    label: "Arts & Culture / આર્ટસ અને કલ્ચર",
    value: "Arts & Culture / આર્ટસ અને કલ્ચર",
  },
  {
    label: "International Awards / આંતરરાષ્ટ્રીય એવોર્ડસ",
    value: "International Awards / આંતરરાષ્ટ્રીય એવોર્ડસ",
  },
  { label: "Advisory / સલાહકાર", value: "Advisory / સલાહકાર" },
];
